import { fetchAll } from '@/services/siteUnitEvents.service';

import * as types from './mutation-types';

export default {
  async fetchSiteUnitEvents({ commit }) {
    commit(types.SET_ERRORS, null);
    try {
      const data = await fetchAll();
      commit(types.SET_SITE_UNIT_EVENTS, data);
    } catch ({ message }) {
      commit(types.SET_ERRORS, true);
    }
  }
};
